import Event from '../../core/Event';

export default class OrderProductsPrevRequested extends Event {
    public static type = 'OrderProductsPrevRequested';

    constructor() {
        super(OrderProductsPrevRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/OrderProductsPrevRequested.ts